import { Component, EventEmitter, Output, Input, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LoginService } from '../../../shared-modules/login/login.service';
import { DomSanitizer } from '@angular/platform-browser';
import { StudentService } from '../../../shared-components/student/student.service';
import { OnlinePaymentConfiguration } from '../../../student360/online-payment/models/online-payment-config.model';
import { Student360Service } from '../../../student360/student360.service';

@Component({
    selector: 'e-form-confirm-submit',
    templateUrl: './e-form-confirm-submit.component.html'
})
export class EFormConfirmSubmitComponent implements OnInit {
    
    @Input() showFeeNote = false;
    @Input() autoAccept = false;
    
    noteMessage: string;
    showSubmitAndPayNow = false;    

    constructor(
        private dialog: MatDialogRef<EFormConfirmSubmitComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private loginService: LoginService,
        private studentService: StudentService,
        private student360Service: Student360Service
    ) {
        
    }

    ngOnInit(): void {
        // Setting injected data
        if (this.data) {
            if (this.data.showFeeNote) {
                this.showFeeNote = this.data.showFeeNote;
            }
            if (this.data.autoAccept) {
                this.autoAccept = this.data.autoAccept;
            }
        }            
        
        if(this.showFeeNote) {

            if(this.autoAccept) {
                const onlinePaymentPortalExists = this.student360Service.parentAssignedPortals.findIndex(portal => portal.PortalName == 'Online Payment') != -1;
                const feesAndBillingPortalExists = this.student360Service.parentAssignedPortals.findIndex(portal => portal.PortalName == 'Fees & Billing') != -1;
                if(onlinePaymentPortalExists && feesAndBillingPortalExists) {
                    this.showSubmitAndPayNow = true;
                }
                
                this.noteMessage = 'NOTE: The fee(s) associated with this form will appear in \'Fees & Billing\'.'
            }
            else {
                this.noteMessage = 'NOTE: The fee(s) associated with this form will appear in \'Fees & Billing\' once this submissions has been accepted.'
            }
        }
    }

    submitClick() {
        this.dialog.close('submit');
    }

    submitAndPayClick() {
        this.dialog.close('submitAndPay');
    }

    cancelClick() {
        this.dialog.close();
    }
}
